import { fetcher } from 'services/helpers/responseHandler'

const messageLimitation = () => fetcher.get('subsidiaries/analysis/message-limitation')

const conversions = () => fetcher.get('subsidiaries/analysis/conversions')

const outreach = () => fetcher.get('subsidiaries/analysis/outreach')

const deliveries = () => fetcher.get('subsidiaries/analysis/deliveries')

const subscribers = () => fetcher.get('subsidiaries/analysis/subscribers')

const analysisApi = {
  messageLimitation,
  conversions,
  outreach,
  deliveries,
  subscribers
}

export default analysisApi
